var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"head-btn"},[_vm._t("head")],2),_c('div',{staticClass:"body-table"},[_vm._t("body")],2),_c('div',{staticClass:"foot-page"},[_vm._t("foot")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }